import type { BasketToken } from "../../aysa_api/models/basket_token.types";
import { Reader, Writer } from "protobufjs/minimal";

export const createBaseBasketToken = (): BasketToken => {
  return {
    token: new Uint8Array(),
    hash: 0,
  };
};

export const decodeBasketToken = (
  reader: Reader,
  length: number
): BasketToken => {
  const end = reader.pos + length;
  const message = createBaseBasketToken();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.token = reader.bytes();

        break;
      case 2:
        message.hash = reader.int32();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeBasketToken = (
  writer: Writer,
  message: BasketToken
): Writer => {
  writer.uint32(10).bytes(message.token);
  writer.uint32(16).int32(message.hash);

  return writer;
};
